import { DiscountType, FeePayer } from '@prisma/client';
import * as yup from 'yup';

export const discountSchema = yup.object({
  name: yup
    .string()
    .trim()
    .min(1, "Name can't be empty")
    .required('Name is required'),
  code: yup
    .string()
    .trim()
    .min(1, "Code can't be empty")
    .test({
      name: 'alphanumeric',
      message: 'Code must be alphanumeric',
      test: value => !value || /^[a-zA-Z0-9]*$/.test(value || ''),
    })
    .nullable()
    .optional(),
  type: yup
    .mixed<DiscountType>()
    .oneOf(Object.values(DiscountType))
    .required('Select a valid discount type'),
  amount: yup
    .number()
    .min(0, 'Amount must be greater than or equal to 0')
    .when('type', {
      is: 'PERCENTAGE',
      then: schema =>
        schema.max(100, 'Percentage must be less than or equal to 100'),
    })
    .required('Amount is required'),
  payer: yup
    .mixed<FeePayer>()
    .oneOf(Object.values(FeePayer))
    .required('Select a valid fee payer'),
  active: yup.boolean().optional(),
});

export const selectDiscountSchema = yup.object({
  discountId: yup
    .string()
    .min(1, "Discount can't be empty")
    .required('Select a discount'),
});

export type DiscountPayload = yup.InferType<typeof discountSchema>;

export type SelectDiscountPayload = yup.InferType<typeof selectDiscountSchema>;
